<template>
  <Header />
  <Heros />
  <Info />
  <Footer />
</template>
<script>
import Header from "@/components/home/Header";
import Heros from "@/components/home/Heros";
import Info from "@/components/home/Info";
import Footer from "@/components/home/Footer";

export default {
  components: {
    Header,
    Heros,
    Info,
    Footer,
  },
};
</script>